/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import { When } from "react-if";
import { CSSObject } from "styled-components";
import { SVGIcon, theme, FlexContainer } from "@nordcloud/gnui";

type Props = {
  message: ReactNode;
  hasIcon?: boolean;
  customCss?: CSSObject;
};

export function NoData({ message, customCss, hasIcon = false }: Props) {
  return (
    <FlexContainer
      justifyContent="center"
      css={[{ padding: hasIcon ? `4rem 0` : "" }, customCss]}
      data-testid="Empty view"
    >
      <When condition={hasIcon}>
        <div css={{ marginRight: theme.spacing.spacing03 }}>
          <SVGIcon name="bulb" size="xxl" />
        </div>
      </When>
      {message}
    </FlexContainer>
  );
}
